import * as React from 'react'
import { useNotify, useDataProvider, fetchStart, fetchEnd } from 'react-admin'
import { useDispatch } from 'react-redux'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'

const RefundButton = ({ record }) => {
  const [open, setOpen] = React.useState(false)
  const [withCosts, setWithCosts] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const dispatch = useDispatch()
  const notify = useNotify()
  const dataProvider = useDataProvider()

  const doRefund = () => {
    setLoading(true)
    dispatch(fetchStart())
    dataProvider
      .create(`payment/${record.id}/refund`, {
        data: { id: record.id, noRefundCosts: !withCosts },
      })
      .then(() => {
        notify(`Gelukt! Het bedrag is teruggestort`)
        setOpen(false)
      })
      .catch((err) => {
        if (err.body?.error?.code === 'INSUFFICIENT_FUNDS') {
          notify(
            'Er staat niet genoeg saldo op de rekening van de merchant',
            'warning'
          )
        } else {
          notify('Er ging iets fout...', 'warning')
        }
      })
      .finally(() => {
        setLoading(false)
        dispatch(fetchEnd())
      })
  }

  // stopPropagation: in de Datagrid (rowClick="show") mag een klik op de knop
  // of in het dialoog niet ook de rij-navigatie triggeren
  return (
    <>
      <Button
        variant="outlined"
        color="secondary"
        size="small"
        onClick={(e) => {
          e.stopPropagation()
          setOpen(true)
        }}
        label="Refund"
        title="Refund"
        disabled={loading}>
        Refund
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        onClick={(e) => e.stopPropagation()}>
        <DialogTitle>Refund uitvoeren</DialogTitle>
        <DialogContent>
          <FormControlLabel
            control={
              <Checkbox
                checked={withCosts}
                onChange={(e) => setWithCosts(e.target.checked)}
              />
            }
            label="Kosten inhouden bij refund"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} disabled={loading}>
            Annuleren
          </Button>
          <Button color="secondary" onClick={doRefund} disabled={loading}>
            Refund
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default RefundButton
